import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        all: [{
            text: "Tourist Visa",
            value: "tourist-visa"
        },
            {
                text: "Business Visa",
                value: "business-visa"
            }
        ],
        query: {},
        filter: '',
        loading: false,
        touristVisaCode: 'tourist-visa'
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filter: state => state.filter,
    touristVisaCode: state => state.touristVisaCode
}

const actions = {
    fetchAll({commit, state}) {
        commit('setLoading', true);
        Http.get(API_URL + VERSION + '/visa-types')
            .then(response => {
                commit('setAll', response.data.data)
            })
            .catch(error => {
                const message = error.response.data.message || error.message
                commit('setError', message)
            })
            .finally(() => {
                commit('setLoading', false)
            })
    },
    resetState({commit}) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
